



































import CompanyUserRequired from "../CompanyRequired";
import {Component, Inject, Watch} from "vue-property-decorator";
import {companyroleid, PurchaseOrder} from "@/modules/models";
import Api from "@/components/shop/Api";
import rd from "@/modules/vRoutedefs";
import EllipsisScroller from "@/components/EllipsisScroller.vue";

@Component({
    components: {
        "at-ellipsis-scroller": EllipsisScroller,
    }
})
export default class OrderListingPage extends CompanyUserRequired {
    @Inject()
    api!: Api;

    orderlist: PurchaseOrder[] = [];

    async loadOrderlist() {
        try {
            this.orderlist = await this.api.listPurchaseOrders(this.company.orgNum);
        } catch (e) {
            this.emitError(e);
        }
    }
    get orderCount() {
        return this.orderlist.length;
    }

    orderPageTo(id: number) {
        return {name: rd.shop.order.name, params: {id: id}};
    }

    get shopPageTo() {
        return {name: rd.shop.name};
    }


    @Watch("$route", {immediate: true})
    onRouteChanged() {
        this.loadOrderlist();
    }

    created() {
        this.requireCompanyRoles([companyroleid.admin]);
    }
}
